import DocumentPreviewModal from "../common/DocumentPreviewModal";
import { AdditionalDocumentDTO } from "../../types/AdditionalDocumentDTO";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  open: boolean;
  document: AdditionalDocumentDTO | null;
  fileBase64: string | null;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onDownload: () => void;
};

export default function AdditionalDocumentPreviewModal({
  open,
  document,
  fileBase64,
  loading,
  error,
  onClose,
  onDownload,
}: Props) {
  const { t } = useAppTranslation("common");

  return (
    <DocumentPreviewModal
      open={open}
      title={document?.fileName ?? t("Podgląd dokumentu")}
      loading={loading}
      error={error}
      fileBase64={fileBase64}
      fileName={document?.fileName ?? null}
      onClose={onClose}
      onDownload={onDownload}
    />
  );
}